import store from '@/store'

// 解析查询参数并返回对象
function getQueryParams() {
  const queryString = window.location.search // 获取查询字符串
  const params = new URLSearchParams(queryString)
  const paramsObj = {}

  for (const [key, value] of params.entries()) {
    paramsObj[key] = value // 将每个参数添加到对象中
  }

  return paramsObj
}

export function telegramEnvInit() {
  const tgParams = getQueryParams()
  tgParams.pageResource === 'telegram'
    ? store.commit('telegram/setTgBtn', false)
    : store.commit('telegram/setTgBtn', true)
}
